import { render } from "./SummaryCell.vue?vue&type=template&id=a37834a2"
import script from "./SummaryCell.vue?vue&type=script&lang=js"
export * from "./SummaryCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__